import { TableSettingsTableTypes } from "@enums/table-settings-table-types";
import { ColumnFiltersState, ExpandedState, PaginationState, SortingState } from "@tanstack/react-table";

export enum TableSettingsActionTypes {
    // Search
    SET_TABLE_SETTINGS_SEARCH_FILTERS = "SET_TABLE_SETTINGS_SEARCH_FILTERS",
    SET_TABLE_SETTINGS_SEARCH_RESULTS_LOADING = "SET_TABLE_SETTINGS_SEARCH_RESULTS_LOADING",
    SET_TABLE_SETTINGS_SEARCH_RESULTS = "SET_TABLE_SETTINGS_SEARCH_RESULTS",
    // Table
    SET_TABLE_SETTINGS_TABLE_PAGINATION = "SET_TABLE_SETTINGS_TABLE_PAGINATION",
    SET_TABLE_SETTINGS_TABLE_EXPANDED = "SET_TABLE_SETTINGS_TABLE_EXPANDED",
    SET_TABLE_SETTINGS_TABLE_FILTERS = "SET_TABLE_SETTINGS_TABLE_FILTERS",
    SET_TABLE_SETTINGS_TABLE_SORT_BY = "SET_TABLE_SETTINGS_TABLE_SORT_BY",
    RESET_TABLE_SETTINGS_TABLE_STATE = "RESET_TABLE_SETTINGS_TABLE_STATE"
}

type SetTableSettingsTablePaginationAction = {
    type: TableSettingsActionTypes.SET_TABLE_SETTINGS_TABLE_PAGINATION,
    payload: {
        tableSettingsTable: TableSettingsTableTypes;
        pagination: Partial<PaginationState>;
        ignorePagination?: boolean;
    }
};

export const setTableSettingsTablePagination = (
    tableSettingsTable: TableSettingsTableTypes,
    pagination: Partial<PaginationState>,
    ignorePagination?: boolean
): SetTableSettingsTablePaginationAction => ({
    type: TableSettingsActionTypes.SET_TABLE_SETTINGS_TABLE_PAGINATION,
    payload: { tableSettingsTable, pagination, ignorePagination }
});

type SetTableSettingsTableFiltersAction = {
    type: TableSettingsActionTypes.SET_TABLE_SETTINGS_TABLE_FILTERS;
    payload: {
        tableSettingsTable: TableSettingsTableTypes;
        columnFilters: ColumnFiltersState;
        ignorePagination?: boolean;
    };
};

export const setTableSettingsTableFilters = (
    tableSettingsTable: TableSettingsTableTypes,
    columnFilters: ColumnFiltersState,
    ignorePagination?: boolean
): SetTableSettingsTableFiltersAction => ({
    type: TableSettingsActionTypes.SET_TABLE_SETTINGS_TABLE_FILTERS,
    payload: { tableSettingsTable, columnFilters, ignorePagination }
});

type SetTableSettingsTableSortByAction = {
    type: TableSettingsActionTypes.SET_TABLE_SETTINGS_TABLE_SORT_BY;
    payload: {
        tableSettingsTable: TableSettingsTableTypes;
        sorting: SortingState;
        ignorePagination?: boolean;
    };
};

export const setTableSettingsTableSortBy = (
    tableSettingsTable: TableSettingsTableTypes,
    sorting: SortingState,
    ignorePagination?: boolean
): SetTableSettingsTableSortByAction => ({
    type: TableSettingsActionTypes.SET_TABLE_SETTINGS_TABLE_SORT_BY,
    payload: { tableSettingsTable, sorting, ignorePagination }
});

type SetTableSettingsTableExpandedAction = {
    type: TableSettingsActionTypes.SET_TABLE_SETTINGS_TABLE_EXPANDED;
    payload: {
        tableSettingsTable: TableSettingsTableTypes;
        expanded: ExpandedState;
    };
};

export const setTableSettingsTableExpanded = (
    tableSettingsTable: TableSettingsTableTypes,
    expanded: ExpandedState,
): SetTableSettingsTableExpandedAction => ({
    type: TableSettingsActionTypes.SET_TABLE_SETTINGS_TABLE_EXPANDED,
    payload: { tableSettingsTable, expanded }
});


type ResetTableSettingsTableStateAction = {
    type: TableSettingsActionTypes.RESET_TABLE_SETTINGS_TABLE_STATE
    payload: {
        tableSettingsTable: TableSettingsTableTypes;
    }
};

export const resetTableSettingsTableState = (
    tableSettingsTable: TableSettingsTableTypes
): ResetTableSettingsTableStateAction => ({
    type: TableSettingsActionTypes.RESET_TABLE_SETTINGS_TABLE_STATE,
    payload: { tableSettingsTable }
});

export type TableSettingsActions =
    SetTableSettingsTablePaginationAction |
    SetTableSettingsTableFiltersAction |
    SetTableSettingsTableSortByAction |
    SetTableSettingsTableExpandedAction |
    ResetTableSettingsTableStateAction